import { z } from 'zod';
import { EMPTY_MATRIX_FILTERS, } from '../logic/training-matrix.js';
const flag = z.enum(['1', 'true', '0', 'false']).optional().transform((v) => v === '1' || v === 'true');
export const trainingMatrixExportQuerySchema = z.object({
    view: z.enum(['all', 'deployed-by-project', 'deployed-flat']).default('all'),
    search: z.string().optional(),
    trade: z.string().optional(),
    agency: z.string().optional(),
    expiring: flag,
    expired: flag,
    missing: flag,
    visaExpiring: flag,
    recentDays: z.coerce.number().int().min(1).max(365).optional(),
    sortBy: z.string().default('name'),
    sortDir: z.enum(['asc', 'desc']).default('asc'),
    workerIds: z.string().optional(),
});
// Compile guard: every filter on the Training page must map to an export query
// param, or "current view" exports silently stop matching the screen again.
const FILTER_PARAM_KEYS = {
    search: 'search',
    trade: 'trade',
    agency: 'agency',
    expiring: 'expiring',
    expired: 'expired',
    missing: 'missing',
    visaExpiring: 'visaExpiring',
    recentActive: 'recentDays',
    recentDays: 'recentDays',
};
void FILTER_PARAM_KEYS;
export function descriptorToExportParams(d) {
    const p = { view: d.view };
    const f = d.filters;
    if (f.search.trim())
        p.search = f.search.trim();
    if (f.trade)
        p.trade = f.trade;
    if (f.agency)
        p.agency = f.agency;
    if (f.expiring)
        p.expiring = '1';
    if (f.expired)
        p.expired = '1';
    if (f.missing)
        p.missing = '1';
    if (f.visaExpiring)
        p.visaExpiring = '1';
    if (f.recentActive)
        p.recentDays = String(f.recentDays);
    if (d.sortBy !== 'name' || d.sortDir !== 'asc') {
        p.sortBy = d.sortBy;
        p.sortDir = d.sortDir;
    }
    return p;
}
export function descriptorFromExportQuery(q) {
    return {
        view: q.view,
        filters: {
            search: q.search ?? '',
            trade: q.trade ?? '',
            agency: q.agency ?? '',
            expiring: q.expiring,
            expired: q.expired,
            missing: q.missing,
            visaExpiring: q.visaExpiring,
            recentActive: q.recentDays !== undefined,
            recentDays: q.recentDays ?? EMPTY_MATRIX_FILTERS.recentDays,
        },
        sortBy: q.sortBy,
        sortDir: q.sortDir,
    };
}
//# sourceMappingURL=training-matrix.js.map